import React from 'react';
import tw from "twin.macro"

const StoreHorarios = ({ horarios }) => {
  // Mapeo de números de días a nombres en español
  const diasSemana = {
    1: 'Lunes',
    2: 'Martes', 
    3: 'Miércoles',
    4: 'Jueves',
    5: 'Viernes',
    6: 'Sábado',
    7: 'Domingo'
  };

  // Función para agrupar días consecutivos con el mismo horario
  const agruparHorarios = (horariosData) => {
    if (!horariosData || typeof horariosData !== 'object') {
      return [];
    }
    
    const grupos = [];
    let grupoActual = null;

    // Iterar del 1 al 7 (lunes a domingo)
    for (let dia = 1; dia <= 7; dia++) {
      const diaKey = dia.toString();
      const horario = horariosData[diaKey] || '';
      
      // Si es el primer día o el horario es diferente al grupo actual
      if (!grupoActual || grupoActual.horario !== horario) {
        // Guardar grupo anterior si existe
        if (grupoActual) {
          grupos.push(grupoActual);
        }
        
        // Crear nuevo grupo
        grupoActual = {
          diaInicio: dia,
          diaFin: dia,
          horario: horario
        };
      } else {
        // Extender grupo actual
        grupoActual.diaFin = dia;
      }
    }
    
    // Agregar el último grupo
    if (grupoActual) {
      grupos.push(grupoActual);
    }

    return grupos;
  };

  // Función para formatear el texto de los días
  const formatearDias = (diaInicio, diaFin) => {
    if (diaInicio === diaFin) {
      return diasSemana[diaInicio];
    } else {
      return `${diasSemana[diaInicio]} a ${diasSemana[diaFin]}`;
    }
  };

  const gruposHorarios = agruparHorarios(horarios);

  if (!horarios) {
    return <div>No hay información de horarios disponible</div>;
  }

  return (
    <div css={tw`pt-6 text-obmed2`}>
        {gruposHorarios.length > 0 ? (
          gruposHorarios.filter(grupo => grupo.horario !== '').map((grupo, index) => (
            <div 
              key={index} 
              css={tw`pt-2`}
            >
              <div css={tw` flex-1`}>
                {formatearDias(grupo.diaInicio, grupo.diaFin)}:
              </div>
              <div css={tw`font-bold `}>
                {grupo.horario.split(', ').map((item, index) => (
                  <div key={index}>{item.replace(/(\d{2}:\d{2})-(\d{2}:\d{2})/, '$1h a $2h')}</div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <div>No se pudieron procesar los horarios</div>
        )}
    </div>
  );
};

export default StoreHorarios;
